import { render, staticRenderFns } from "./BankNameTable.vue?vue&type=template&id=36cbbba2&"
import script from "./BankNameTable.vue?vue&type=script&lang=js&"
export * from "./BankNameTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports